import { Button } from '@/components/ui-kit/button';

interface GuestPaywallBannerProps {
  onPay: () => void;
}

/**
 * Soft-gate banner shown to unpaid guests above the review layout. Pitches the
 * one-time unlock for Download / Edit / Letterhead. Authenticated users never
 * see this — the caller gates on `isGuestUnpaid && draftId`.
 */
export function GuestPaywallBanner({ onPay }: GuestPaywallBannerProps) {
  return (
    <div className="px-4 sm:px-6 pt-4">
      <div className="rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 flex items-center justify-between gap-4">
        <div className="text-sm text-amber-900">
          <span className="font-semibold">Preview mode.</span> Pay $5.00 once to unlock Download,
          Edit, and Letterhead for this document.
        </div>
        <Button
          size="sm"
          className="bg-selise-blue hover:bg-oxford-blue text-white shrink-0"
          onClick={onPay}
        >
          Pay $5.00
        </Button>
      </div>
    </div>
  );
}
